import { ReactElement, JSXElementConstructor } from "react";
import { IEntityChildren } from "./EntityChildren";

export interface IEntityListState<T> {
    SelectedEntity: number | null;
    SelectedEntityChildren: IEntityChildren[];
    ShowForm: boolean;
    ShowForm2: boolean;
    ShowViewForm: boolean;
    Entities: { Timestamp: number | null, Items: T[] };
    HideDeleteDialog: boolean;
    HideDeleteDisallowed: boolean;
    EnableEdit?: boolean;
    EnableView?: boolean;
    EnableDelete?: boolean;
    EnableAddChild?: boolean;
    ListFilterText?: string | null;
    LoadingListData: boolean;
    LoadingDeleteCheck: boolean;
    ShowChildForm: boolean;
    ShowClosedEntities: boolean;
    EntityDescriptionLine1: string;
    EntityDescriptionLine2: string;
    EntityDescription1ForList: string;
    EntityDescription1ForForm: string;
    EntityDescription1DirectorateID?: number;
    HideCustomDeleteDisallowed: boolean;
    CustomDeleteMsg: React.ReactElement;
    HTMLDeleteMsg: React.ReactElement;
    SelectionPreservedOnEmptyClick: boolean;
    showGanttView: boolean;
    GanttHeight: number;
    CurrentZoomLevel?: number;
    GanttApi?: any;

}

export class EntityListState<T> implements IEntityListState<T> {
    public SelectedEntity = null;
    public SelectedEntityChildren = [];
    public ShowForm = false;
    public ShowForm2 = false;
    public ShowViewForm = false;
    public Entities = { Timestamp: null, Items: [] };
    public HideDeleteDialog = true;
    public HideDeleteDisallowed = true;
    public EnableEdit = false;
    public EnableView = false;
    public EnableDelete = false;
    public EnableAddChild = false;
    public ListFilterText = null;
    public LoadingListData = false;
    public LoadingDeleteCheck = false;
    public ShowChildForm = false;
    public ShowClosedEntities = false;
    public EntityDescriptionLine1 = '';
    public EntityDescriptionLine2 = '';
    public EntityDescription1ForList = '';
    public EntityDescription1ForForm = '';
    public EntityDescription1DirectorateID = null;
    public HideCustomDeleteDisallowed = true;
    public CustomDeleteMsg = null;
    public HTMLDeleteMsg = null;
    public SelectionPreservedOnEmptyClick = false;
    public showGanttView = false;
    public GanttHeight = 600;
    public CurrentZoomLevel = 1;
    public GanttApi = null;
}
